/**
 * Vue 与 Canvas 游戏运行时之间的唯一调用入口。
 * 页面/Store 不应该直接操作 window.game，也不要直接改 runtime 内部状态。
 */
function runtime() {
  return window.BricksBeaterGame;
}

export const gameRuntimeBridge = Object.freeze({
  isReady: () => Boolean(runtime()),
  startLevel: (level, options) => runtime()?.startLevel?.(level, options),
  startCustomLevel: (payload, options) => runtime()?.startCustomLevel?.(payload, options),
  setBeforeFirstLaunch: handler => runtime()?.setBeforeFirstLaunch?.(handler),
  setBeforeSkillUse: handler => runtime()?.setBeforeSkillUse?.(handler),
  setSkillInventory: snapshot => runtime()?.setSkillInventory?.(snapshot) ?? null,
  setClearRewards: snapshot => runtime()?.setClearRewards?.(snapshot) ?? null,
  setFragmentReward: amount => runtime()?.setFragmentReward?.(amount) ?? null,
  setLanguage: language => runtime()?.setLanguage?.(language),
  setSettings: settings => runtime()?.setSettings?.(settings),
  setSkin: selection => runtime()?.setSkin?.(selection),
  setCollectedScenicLevels: levels => runtime()?.setCollectedScenicLevels?.(levels),
  refreshProgress: () => runtime()?.refreshProgress?.(),
  leaveGame: options => runtime()?.leaveGame?.(options),
  getSnapshot: () => runtime()?.getSnapshot?.() ?? null,
  getEnergy: () => runtime()?.getEnergy?.() ?? null,
  setEnergy: snapshot => runtime()?.setEnergy?.(snapshot) ?? null,
  pause: () => runtime()?.pause?.(),
  resume: () => runtime()?.resume?.(),
  setProgressFromHome: home =>
    runtime()
      ?.setProgressFromHome?.(home)
      ?? null,
  previewClearResult: () => runtime()?.previewClearResult?.() ?? false,

});
